import axios from "axios";
import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { getAllCity, getCateg, getLocation, getLocations } from "../../../apifile/ApiFiles";
import { exportToExcel } from "../../../../common/ExcelDownlaod";
const CandidateReportTable = ({ dataExcel, getCandidatelistDataFilter, getCandidatelistData }) => {
  const [categorydata, setCategorydata] = useState();
  const [locationdata, setLocationdata] = useState();
  const [Citydata, setCitydata] = useState()
  const getData = async () => {
    try {
      const rescategory = await getCateg()
      console.log(rescategory);
      const maped = rescategory?.data?.map((item) => {
        return { ...item, value: item.category_name, label: item.category_name }
      })


      setCategorydata(maped);

    } catch (error) {
      alert("wrog");
    }
  };
  const getData1 = async () => {
    try {

      // const reslocation = await getLocation()
      const reslocation = await getLocations()
      // console.log(reslocation);
      setLocationdata(reslocation);
      // const res = await getAllCity()
      // setCitydata(res?.data);
    } catch (error) {
      alert("wrog");
    }
  };

  useEffect(() => {
    getData();
    getData1();

  }, []);
  const [data, setData] = useState({
    name: '',
    dateFrom: '',
    dateTo: '',
    mobile: '',
    email: '',
    job_category: '',
    location: '',
    status: '',
  })
  const onchangeHandle = (e) => {
    const clone = { ...data }
    clone[e.target.name] = e.target.value
    setData(clone)
  }
  const [showCateg, setShoCagte] = useState([])
  const onchangeHandleCateg = (e) => {
    const clone = { ...data, job_category: e._id }
    setShoCagte([{ ...e }])
    setData(clone)
  }
  const resetFnData = () => {
    getCandidatelistData()
    setData({
      name: '',
      dateFrom: '',
      dateTo: '',
      mobile: '',
      email: '',
      job_category: '',
      location: '',
      status: '',
    })
  }

  const downloadExcel = (str) => {
    exportToExcel(str)
  }
  return (
    <>
      <div className="candidate_report_bg bg-dark text-white">
        All Candidate list Report
      </div>
      <div className="pageBody">
        <div className="pageTable">
          <form>
            <div className="row mb-3">
              <div className="form-group mb-3 col-lg-4 col-md-6">
                <label htmlFor="language_level">
                  <strong>Name</strong>
                </label>
                <input
                  className="form-control"
                  placeholder="Name"
                  type="text"
                  value={data.name}
                  name="name"
                  onChange={onchangeHandle}
                />
              </div>

              {/* <div className="form-group mb-3 col-lg-4 col-md-6">
                <label htmlFor="language_level">
                  <strong>From</strong>
                </label>
                <input
                  className="form-control"
                  placeholder="From"
                  type="date"
                  value={data.dateFrom}
                  name="dateFrom"
                  onChange={onchangeHandle}
                />
              </div>

              <div className="form-group mb-3 col-lg-4 col-md-6">
                <label htmlFor="language_level">
                  <strong>to</strong>
                </label>
                <input className="form-control" placeholder="to" type="date" value={data.dateTo}
                  name="dateTo"
                  onChange={onchangeHandle} />
              </div> */}

              <div className="form-group mb-3 col-lg-4 col-md-6">
                <label htmlFor="language_level">
                  <strong>Mobile 1</strong>
                </label>
                <input
                  className="form-control"
                  placeholder="Mobile 1"
                  type="number"
                  value={data.mobile}
                  name="mobile"
                  onChange={onchangeHandle}
                />
              </div>

              <div className="form-group mb-3 col-lg-4 col-md-6">
                <label htmlFor="language_level">
                  <strong>Email 1</strong>
                </label>
                <input
                  className="form-control"
                  placeholder="daniyan@11229"
                  type="email"
                  value={data.email}
                  name="email"
                  onChange={onchangeHandle}
                />
              </div>

              <div className="form-group mb-3 col-lg-4 col-md-4">
                <label htmlFor="lang" className="mb-1 ">
                  <strong>Category</strong>
                </label>
                <Select
                  // isMulti
                  defaultValue={showCateg}
                  value={showCateg}
                  name="job_category"
                  options={categorydata}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={onchangeHandleCateg}
                />
                {/* <select
                  className="form-select"
                  name="category"
                  value={data.category}
                  onChange={onchangeHandle}
                >
                  <option>Select Category</option>
                  {categorydata &&
                    categorydata?.map((item) => {
                      return (
                        <option value={item._id}>{item.category_name}</option>
                      );
                    })}
                </select> */}
              </div>

              <div className="form-group mb-3 col-lg-4 col-md-4">
                <label htmlFor="lang" className="mb-1 ">
                  <strong>Location / City</strong>
                </label>
                <select
                  className="form-select"
                  name="location"
                  value={data.location}
                  onChange={onchangeHandle}
                >
                  <option value={null}>Select Location / City</option>
                  {locationdata?.data &&
                    locationdata?.data?.map((item) => {
                      return (
                        <option value={item._id}>{item.location_name}</option>
                      );
                    })}
                </select>
              </div>

              <div className="form-group mb-3 col-lg-4 col-md-4">
                <label htmlFor="lang" className="mb-1 ">
                  <strong>Status</strong>
                </label>
                <select className="form-select" name="status"
                  value={data.status}
                  onChange={onchangeHandle}>
                  <option value="" selected>Select Status</option>
                  <option value={1}>Active</option>
                  <option value={0}>In Active</option>
                </select>
              </div>

              <div className="mb-3 col-lg-12 text-center">
                <div className="bt_container">
                  <a href="#" type="btn" className="btn btn-primary me-2" onClick={() => { getCandidatelistDataFilter(data) }}>
                    Search
                  </a>
                  <button type="button" className="btn btn-primary" onClick={() => downloadExcel(dataExcel)}>
                    Download
                  </button>
                  <a href="#" type="btn" className="btn btn-primary" style={{ margin: "0 7px" }} onClick={resetFnData}>
                    Reset
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CandidateReportTable;
